/**
 * DataBinsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'

import DataBinsContext from './data-bins-context'
import {
  fetchDataBinsBySlugName,
  updateDataBinsBySlugName
} from './data-bins-api'

export default function DataBinsProvider({ children }) {
  const contextValue = {
    fetchDataBinsBySlugName,
    updateDataBinsBySlugName
  }
  return (
    <DataBinsContext.Provider value={contextValue}>
      {children}
    </DataBinsContext.Provider>
  )
}
